import { createSlice } from "@reduxjs/toolkit";

// Define initial state for the slice.

const initialState = {
  data: [],
  loading: false,
  error: null,
  request: null,
  ActionRequestCount: { distribution: 0 },
  ids: [],
};

//  Define slice and it's reducer functions.
const ProvinceActionRequestSlice = createSlice({
  name: "provinceActionRequest",
  initialState,
  reducers: {
    setData(state, action) {
      state.data = action.payload;
    },
    setLoading(state, action) {
      state.loading = action.payload;
    },
    setError(state, action) {
      state.error = action.payload;
    },
    setProject(state, action) {
      state.project = action.payload;
    },
    setActionRequestCount(state, action) {
      state.ActionRequestCount = action.payload;
    },
    setIds(state, action) {
      state.ids = action.payload;
    },
    setNewIds(state, action) {
      state.ids = [...state.ids, action.payload];
    },
    resetState(state) {
      state.data = [];
      state.loading = false;
      state.error = null;
      state.project = null;
    },
    resetIds(state) {
      state.ids = [];
    },
  },
});

export const ProvinceActionRequestAction = ProvinceActionRequestSlice.actions;

export default ProvinceActionRequestSlice;
